module.exports = __webpack_public_path__ + "img/oremodel.525184db.jpg";